import React from 'react';
import PropTypes from 'prop-types';

import './Alert.scss';

export default function Alert({ children, className, style, type }) {
  return (
    <div className={`alert ${type} ${className}`} style={style}>
      {children}
    </div>
  );
}
Alert.propTypes = {
  children: PropTypes.string.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};
Alert.defaultProps = {
  className: '',
  style: {},
  type: '',
};
